import _slicedToArray from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { Column, ColumnItem } from '../column';
import { Icon } from '../../ui/icon';
import { CloseFill, Warning } from '../../ui/icon/iconList/fontIcons';
import S from './style/styled';
export var Modal = function Modal(_ref) {
  var title = _ref.title,
      actions = _ref.actions,
      _ref$alignActions = _ref.alignActions,
      alignActions = _ref$alignActions === void 0 ? 'right' : _ref$alignActions,
      anchor = _ref.anchor,
      style = _ref.style,
      children = _ref.children,
      handleClickOutside = _ref.handleClickOutside,
      height = _ref.height,
      _ref$hasHeader = _ref.hasHeader,
      hasHeader = _ref$hasHeader === void 0 ? true : _ref$hasHeader,
      _ref$hasHeaderButton = _ref.hasHeaderButton,
      hasHeaderButton = _ref$hasHeaderButton === void 0 ? true : _ref$hasHeaderButton,
      isOpen = _ref.isOpen,
      width = _ref.width,
      isFullScreen = _ref.isFullScreen,
      leftArea = _ref.leftArea,
      rightArea = _ref.rightArea,
      warningModal = _ref.warningModal;
  var modalContainerRef = React.useRef(null);

  var _React$useState = React.useState(isFullScreen ? [0, 0, window.innerWidth, window.innerHeight] : [50, 0, 480, height]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      size = _React$useState2[0],
      setSize = _React$useState2[1];

  if (isFullScreen && (height !== undefined || width !== undefined || anchor !== undefined)) {
    console.warn('cannot set height & width when using isFullSize prop');
  }

  React.useEffect(function () {
    if (modalContainerRef.current && isOpen) {
      modalContainerRef.current.focus();
    }
  }, [isOpen]);
  React.useEffect(function () {
    var currentAnchor = anchor && anchor.current;

    if (currentAnchor) {
      currentAnchor.scrollIntoView();

      var _currentAnchor$getBou = currentAnchor.getBoundingClientRect(),
          top = _currentAnchor$getBou.top,
          left = _currentAnchor$getBou.left,
          _width = _currentAnchor$getBou.width,
          _height = _currentAnchor$getBou.height;

      setSize([top, left, _width, _height]);
    }

    if (isFullScreen) {
      setSize([0, 0, window.innerWidth, window.innerHeight]);
    }
  }, [isOpen, anchor, isFullScreen]);
  React.useEffect(function () {
    if (handleClickOutside) {
      isOpen = false;
    }
  }, [handleClickOutside]);

  if (!isOpen) {
    return null;
  }

  return React.createElement(React.Fragment, null, React.createElement(S.ModalOverlay, {
    onClick: handleClickOutside
  }), React.createElement(S.ModalContainer, {
    warningModal: warningModal,
    style: style,
    tabIndex: 0,
    ref: modalContainerRef,
    alignActions: alignActions,
    top: size[0],
    left: size[1],
    width: width || size[2],
    height: height,
    modalHeight: modalContainerRef.current && modalContainerRef.current.clientHeight
  }, React.createElement(S.ModalBody, {
    isFullSize: isFullScreen,
    title: title
  }, warningModal && React.createElement(S.ModalWarningWrapper, {
    warningModal: warningModal
  }, React.createElement(Icon, {
    size: 'large',
    src: React.createElement(Warning, null)
  })), hasHeader ? React.createElement(S.ModalHeader, {
    warningModal: warningModal
  }, React.createElement(S.ModalTitle, {
    warningModal: warningModal
  }, title), hasHeaderButton ? React.createElement(S.ModalHeaderAction, {
    onClick: handleClickOutside
  }, React.createElement(Icon, {
    src: React.createElement(CloseFill, null)
  })) : null) : null, React.createElement(S.ModalContent, {
    actions: Boolean(actions),
    anchor: Boolean(anchor),
    top: size[0]
  }, (leftArea || rightArea) && React.createElement(Column, null, leftArea && React.createElement(ColumnItem, {
    size: 6
  }, React.createElement(S.ModalContentLeftArea, null, leftArea)), rightArea && React.createElement(ColumnItem, {
    size: 6
  }, React.createElement(S.ModalContentRightArea, null, rightArea))), React.createElement(Column, null, React.createElement(ColumnItem, {
    size: 12
  }, React.createElement(S.ModalFullWidthArea, null, children)))), actions && React.createElement(S.ModalActions, {
    childCount: actions.length,
    alignActions: alignActions
  }, actions))));
};